import styled from 'styled-components';

export const BookingOptionOuterWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
      border-top: 1px dashed ${props.theme.colors.grey.lighte7};
      position: relative;
  `
);

export const LeftCircleCut = styled.div(
  props => `
      width:1.6rem;
      height: 1.6rem;
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      left: -0.8rem;
      top: -0.8rem;
      z-index:2;
      background-color: ${props.theme.colors.grey.lightf2};
  `
);

export const RightCircleCut = styled.div(
  props => `
      width:1.6rem;
      height: 1.6rem;
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      right: -0.8rem;
      top: -0.8rem;
      z-index:2;
      background-color: ${props.theme.colors.grey.lightf2}
  `
);

export const BookingOptionInnerWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;
  `
);

export const BookingOptionWrap = styled.div(
  props => `
      align-self: flex-start;
      display: flex;
      align-items: center;
      // width:25%;
      padding-right: 1rem;
      cursor : pointer;
  `
);

export const OptionIconWrap = styled.div(
  props => `
      display: flex;
      width: 3.2rem;
      height: 3.2rem;
      align-items: center;
      justify-content: center;
      // background-color: ${props.theme.colors.blue.lightea};
      // border-radius: ${props.theme.misc.borderRadius.round};
  `
);

export const OptionTextWrap = styled.div(
  props => `
      display: flex;
      display
`
);

export const OptionText = styled.a(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.blue.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    cursor: pointer;
    text-decoration: none;
    margin-right : 5px
  `
)

export const ProfileStatus = styled.a`
    padding: 2px 4px;
    background-color: #128c7e;
    font-size: 1.2rem;
    text-align: right;
    border-radius: .4rem;
    display:inline-block;
    font-family : Helvetica;
    color : white;
    font-weight : bold
  `;
